<template>
  <section id="solucoes" class="section bg-gray solutions-section" style="padding: 48px 0 !important">
    <div class="container">
      <h2 class="text-center mb-2">
        Soluções digitais para o seu município
      </h2>
      <p class="text-center text-muted mb-5 col-lg-8 mx-auto">
        Conjunto de sistemas em uso na gestão pública: cadastros, processos seletivos e educação corporativa.
      </p>

      <div class="row">
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="card solution-card h-100 border-0 ibcgp-card-elevated">
            <div class="card-body d-flex flex-column">
              <div class="mb-3">
                <i class="ti-layout-grid2-alt text-primary h2"></i>
              </div>
              <h3 class="h5 card-title">
                Plataforma Rural
              </h3>
              <ul class="solution-list pl-3 mb-4 flex-grow-1">
                <li>Cadastro e gestão de imóveis rurais e integrações com CAFIR, INCRA, SIGEF e CAR</li>
                <li>Gestão do Imposto Territorial Rural (ITR) e análises tributárias</li>
                <li>Fiscalização e rotinas de auto regularização e malha fiscal</li>
                <li>Painéis, relatórios e apoio à tomada de decisão</li>
              </ul>
              <a
                :href="links.plataformaGestao"
                class="btn btn-outline-primary btn-sm mt-auto align-self-start"
                target="_blank"
                rel="noopener noreferrer"
              >
                Acessar plataforma
              </a>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 mb-4">
          <div class="card solution-card h-100 border-0 ibcgp-card-elevated">
            <div class="card-body d-flex flex-column">
              <div class="mb-3">
                <i class="ti-blackboard text-primary h2"></i>
              </div>
              <h3 class="h5 card-title">
                Concursos e processos seletivos
              </h3>
              <ul class="solution-list pl-3 mb-4 flex-grow-1">
                <li>Inscrição de candidatos e publicação dos editais e comunicados</li>
                <li>Área do candidato e acompanhamento do processo</li>
                <li>Boletos, isenções e recursos</li>
                <li>Camada administrativa e de auditoria para o órgão público</li>
              </ul>
              <a
                :href="links.concursosPublico"
                class="btn btn-outline-primary btn-sm mt-auto align-self-start"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver concursos
              </a>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-12 mb-4">
          <div class="card solution-card h-100 border-0 ibcgp-card-elevated">
            <div class="card-body d-flex flex-column">
              <div class="mb-3">
                <i class="ti-book text-primary h2"></i>
              </div>
              <h3 class="h5 card-title">
                Cursos e capacitação
              </h3>
              <ul class="solution-list pl-3 mb-4 flex-grow-1">
                <li>Trilhas de cursos, vídeos e materiais complementares</li>
                <li>Emissão de certificados</li>
                <li>Fóruns de discussão e sessões ao vivo</li>
                <li>Gestão do educando e acompanhamento de participação</li>
              </ul>
              <div class="d-flex flex-wrap gap-links">
                <a
                  :href="links.cursosLanding"
                  class="btn btn-outline-primary btn-sm mr-2 mb-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Conhecer cursos
                </a>
                <a
                  :href="links.cursosPlataformaLogin"
                  class="btn btn-outline-secondary btn-sm mb-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Área do aluno
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import links from '../../../consts/links.js'

export default {
  name: 'SolutionsSection',
  data () {
    return { links }
  }
}
</script>

<style scoped>
.solution-card {
  border-radius: 8px;
  background: #fff;
}

.solution-list li {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  line-height: 1.45;
}

.gap-links {
  margin-top: auto;
}

.solutions-section h2 {
  font-size: 1.65rem;
  font-weight: 700;
  color: #02225b;
}

.solutions-section h3 {
  font-weight: 600;
  color: #2d3748;
}
</style>
